import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { GlobalService } from './global.service';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  constructor(private http: HttpClient,public router: Router, private globalservice: GlobalService) {}

  headers = new HttpHeaders().set('Content-Type', 'application/json');
  loginError: string='';

  getHeaders() {
    return new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization:'Bearer ' +  sessionStorage.getItem(this.globalservice.LOGIN_TOKEN)
    });
  }

  
  login(model: any) {
 
   this.loginError='';
    return this.http.post(this.globalservice.getEndPoint() + 'auth/login', model).pipe(
      map((response: any) => {
        const user = response.user;
       
        
      
        if (response.Errore) {
           this.loginError = response.Errore;
        } else {
          this.updateUser(user);
          this.loginError = '';
          if (response.TokenAnswer && response.TokenAnswer !== '') {
            sessionStorage.setItem(this.globalservice.LOGIN_TOKEN, response.TokenAnswer);
            this.updateToken(response.TokenAnswer);
          }
        }
      })
    );
  }

  updateUser(user:any){
    localStorage.removeItem(this.globalservice.USER_KEY);
     user.userInitials='AA';
     user.fullName='';
     if((user.name)&&(user.name!='')&&(user.surname)&&(user.surname!='')){
       user.fullName=user.name+' '+user.surname;
       user.userInitials=''+Array.from(user.name)[0]+Array.from(user.surname)[0];
       user.userInitials=user.userInitials.toUpperCase();
     }
     localStorage.setItem(this.globalservice.USER_KEY,  JSON.stringify(user));
    
  }

  public updateToken(token: string) {
    if(token){
      sessionStorage.setItem(this.globalservice.LOGIN_TOKEN, token);
    }
  }

  public logout() {
    sessionStorage.clear();
    localStorage.removeItem(this.globalservice.USER_KEY);
    this.router.navigate(['']);
  }

  public isLoggedIn(): boolean {
    const token=sessionStorage.getItem(this.globalservice.LOGIN_TOKEN);
    if(!token){
      return false;
    }
    const user:any = JSON.parse(localStorage.getItem(this.globalservice.USER_KEY)!);
    if (user) {
      this.globalservice.userInitials=user.userInitials;
      if(user.userInitials){
        this.globalservice.userInitials=user.userInitials;
      } else {
        this.globalservice.userInitials="  ";
      }
      if(user.fullName){
        this.globalservice.fullName=user.fullName;
      } else {
        this.globalservice.fullName='';
      }
      return true;
    }
    return false;
  }
}
